import React, { useMemo, useState } from 'react';

import { Popover } from 'react-tiny-popover';
import css from './CardSources.module.css';
import OutlineSource from '../../../../../icons/SourceOutline';
import { supportsContainerQueries } from '../../../../../utils/css';
import Source from '../../../Source/Source';

function SourcesMenu({ sources, showMore }) {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  return (
    <Popover
      isOpen={isPopoverOpen}
      positions={['bottom']}
      containerStyle={{ zIndex: 99 }}
      onClickOutside={() => setIsPopoverOpen(false)}
      content={
        <ul className={css.menu}>
          {sources.map((source) => (
            <li key={source}>
              <Source src={source} />
            </li>
          ))}
        </ul>
      }
    >
      <div className={css.sourcesInMenu} onClick={() => setIsPopoverOpen(true)}>
        {showMore && '+ '}
        {sources.length}
        {!showMore && <OutlineSource />}
      </div>
    </Popover>
  );
}

/*
 * If card size < 600px, show sources inside menu
 * If card size > 600px, show fisrt source inline and rest inside menu
 */
function FlexSources({ sources = [] }) {
  if (sources.length === 0) return null;

  return (
    <div>
      <div className={css.smallScreen}>
        <SourcesMenu sources={sources} />
      </div>
      <div className={css.largeScreen}>
        <Source src={sources[0]} />
        {sources.length > 1 && (
          <SourcesMenu sources={sources.slice(1)} showMore />
        )}
      </div>
    </div>
  );
}

function FallbackSources({ sources }) {
  return (
    <div>
      <SourcesMenu sources={sources} />
    </div>
  );
}

function CardSources({ sources = [], ...props }) {
  // only render inline sources if browser support container query
  const supportContainerQuery = useMemo(() => supportsContainerQueries(), []);

  return (
    <div {...props} className={css.sources}>
      {supportContainerQuery && <FlexSources sources={sources} />}

      {!supportContainerQuery && <FallbackSources sources={sources} />}
    </div>
  );
}

export default CardSources;
